import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ShoreexcursionsService {
  OBPortalSvcURL = '';
  busSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public getShoreExcursions(
    rebcode: string | undefined,
    asofdate: string | undefined
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const ShoreExcursionInfo: JSON = <JSON>(<unknown>{
      rebcode: rebcode,
      asofdate: asofdate,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetShoreExcursions',
      JSON.stringify(ShoreExcursionInfo),
      { headers: headers }
    );
  }
  public getCruiseShoreExcursions(
    cruiseCode: string | undefined
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const ShoreExcursionInfo: JSON = <JSON>(<unknown>{
      cruiseCode: cruiseCode,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetCruiseExcursions',
      JSON.stringify(ShoreExcursionInfo),
      { headers: headers }
    );
  }
  public getBookingHash(BookingCode: string | undefined): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const BookingInfo: JSON = <JSON>(<unknown>{
      BookingCode: BookingCode,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'GetHashFromBookingCode',
      JSON.stringify(BookingInfo),
      { headers: headers }
    );
  }
}
